import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || process.env.VITE_SUPABASE_URL || process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  process.env.VITE_SUPABASE_ANON_KEY ||
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Faltan variables de Supabase. Define REACT_APP_SUPABASE_URL y REACT_APP_SUPABASE_ANON_KEY (o VITE_/NEXT_PUBLIC_ equivalents).'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
